/* eslint-disable no-param-reassign */
import { PayloadAction } from '@reduxjs/toolkit';
import { State } from '../menu-list.slice';

export default function updateTotalCount(
  state: State,
  action: PayloadAction<number>,
): void {
  state.totalCount = action.payload;
}
